import Reveal, { SectionLabel } from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";

const CASES = [
  {
    img: "/proof/t5.jpeg",
    pos: "center top",
    member: "William T.",
    badge: "+$858.85",
    caption: "Five XAUUSD sells, one plan — shared live in the community chat.",
    testid: "case-study-card-1",
  },
  {
    img: "/proof/t3.jpeg",
    pos: "center top",
    member: "William T.",
    badge: "+$1,034.00",
    caption: "“Asia served me well after nearly holding me hostage.”",
    testid: "case-study-card-2",
  },
  {
    img: "/proof/r-blaine.jpeg",
    pos: "center top",
    member: "Blaine J.",
    badge: "+£375.85",
    caption: "Nine positions, one session, every fill documented.",
    testid: "case-study-card-3",
  },
  {
    img: "/proof/t1.jpeg",
    pos: "center top",
    member: "Farmann",
    badge: "+$1,361.30",
    caption: "Four sells closed in ninety seconds. “Boooooooom” was the caption.",
    testid: "case-study-card-4",
  },
  {
    img: "/proof/t2.jpeg",
    pos: "center 30%",
    member: "Lollyfx",
    badge: "+$189.18 NET",
    caption: "Even the −$4.09 got shared. Wins and losses alike — that's the standard.",
    testid: "case-study-card-5",
  },
  {
    img: "/proof/r-mahesh.jpeg",
    pos: "center 25%",
    member: "Mahesh",
    badge: "+£7,915.89",
    caption: "“This was my 5k account btw.” Equity minus balance — floating profit, mid-move.",
    testid: "case-study-card-6",
  },
];

const CaseStudies = () => (
  <section id="results" className="relative py-24 lg:py-36" data-testid="results-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-14 lg:mb-20">
        <Reveal>
          <SectionLabel>Real Members. Real Progress.</SectionLabel>
          <h2 className="mt-5 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-50 leading-tight max-w-2xl" data-testid="results-title">
            Screenshots straight from
            <span className="text-gold-gradient"> the community chat.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="text-sm text-slate-500 max-w-xs leading-relaxed">
            Real XAUUSD results shared by Atlas members — wins and losses alike. That's the standard.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {CASES.map((c, i) => (
          <Reveal key={c.testid} delay={(i % 3) * 0.12}>
            <article className="group" data-testid={c.testid}>
              <div className="relative chart-frame overflow-hidden border border-line bg-black group-hover:border-gold/40 transition-colors duration-500">
                <img
                  src={c.img}
                  alt={`${c.member} XAUUSD results shared in the Atlas community`}
                  loading="lazy"
                  className="w-full aspect-[5/4] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                  style={{ objectPosition: c.pos }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent" />
                <span className="absolute top-4 right-4 bg-ink/80 backdrop-blur border border-gold/40 text-gold font-mono text-[11px] tracking-[0.15em] px-3 py-1.5 rounded-sm">
                  {c.badge}
                </span>
                <span className="absolute bottom-4 left-4 font-mono text-[10px] tracking-[0.25em] text-slate-300 uppercase">Atlas Member · XAUUSD</span>
              </div>
              <p className="mt-4 text-sm text-slate-400 leading-relaxed">{c.caption}</p>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-12 flex items-start gap-3 border border-line/70 rounded-md px-5 py-4 bg-panel/40" data-testid="results-disclaimer">
          <ArrowUpRight size={15} className="text-gold mt-0.5 shrink-0" />
          <p className="text-[11px] sm:text-xs text-slate-500 leading-relaxed">
            Member screenshots shared with permission. Past performance is not a guarantee of future results.
            Trading involves substantial risk. Atlas teaches analysis and risk discipline — we never promise returns,
            and nothing here is financial advice.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CaseStudies;
